<!--
 by:wangyingyu
 2019.9.18
 -->
<template>
    <div class="chat">
        <!-- 主体 -->
        <div class="chatbox" :class="{'searchchat':searchdata}">
            <!-- <div class="title" v-if="!searchdata || searchdata.type !=1">

                <div class="txt" v-if="showchatdailg == 2">查看聊天记录</div>
                <a href="javascript:;" v-show="showchatdailg!=1" @click='closechat' class="btn_close el-icon-close"></a>

            </div> -->

            <!-- 聊天窗口 -->
            <div class="chatCon">
                <el-scrollbar style="height: 100%;" ref='scrollbar' v-if="chatdata!=undefined">

                    <!-- 加载更多 -->
                    <a href="javascript:;" class="btn_moreinfo" @click="getmoreHistoryWechatMessage" v-show="chatdata.length!=0&&ismore!=false">加载更多消息</a>

                    <!-- 显示更多结果 -->
                    <div class="searchResult" v-show="!ismore">
                        <p> 没有更多聊天记录</p>
                    </div>

                    <!-- 聊天记录 -->
                    <div class="chatlist">
                        <ul>
                            <li :id="'id'+item.id" :class="{chatsend:item.isSend=='true',chatreceive:item.isSend=='false'}" v-for="(item,index) in chatdata"
                                :key="index">
                                <i :class="{active:chatmsg.idlists.indexOf('id'+item.id)!=-1,nosle:item.outsideTableId!=undefined&&item.outsideTableId!=''}">
                                    <s class="el-icon-check"></s>
                                </i>

                                <!-- 系统消息 -->
                                <p class="chattip" v-if="item.contentType=='5' || item.contentType=='101'" >
                                    <span v-if="item.content.indexOf('开启了朋友验证') != -1">
                                        {{item.nickname}}开启了朋友验证，你还不是他（她）朋友。请先发送朋友验证请求，对方验证通过后，才能聊天。
                                        <!-- <i>发送朋友验证</i> -->
                                    </span>
                                    <span v-else v-html="item.content"></span>
                                </p>
                                <div class="chattip" v-if="item.contentType=='16'">
                                    <div class="red_state"><img src="/static/img/icon_redenvelop.png" alt="">{{ JSON.parse(item.content).Title }}</div>
                                </div>
                                <!-- <p class="time">{{item.createTime}}</p> -->
                                <div class="chatmsg clearfix" v-if="item.contentType!='5' && item.contentType!='101' &&item.contentType!='16'&&item.contentType!=undefined">
                                    <img :src="item.avatar" alt=""  :onerror="errorImg">

                                    <div class="chattxt chatother" v-if="item.contentType=='2'||item.contentType=='3'||item.contentType=='4'||item.contentType=='14'">

                                        <!-- 图片 -->
                                        <!-- <img v-if="item.contentType=='14'" style="max-width: 120px;" :src="item.content" alt=""> -->
                                        <div class="imgshowbox" v-if="item.contentType=='2' || item.contentType=='14'">
                                            <div v-if="item.content.indexOf('{') != -1 && item.content.indexOf('}') != -1&& item.content.indexOf('http') != -1">
                                                <el-image ref="imgview" style="max-width: 120px;max-height: 214px;vertical-align: middle" @click='getsrcList(JSON.parse(item.content).LinkUrl,item.msgId)'
                                                    v-if="item.contentType=='2' && JSON.parse(item.content).LinkUrl" :src="JSON.parse(item.content).Thumb ? JSON.parse(item.content).Thumb : '/static/img/icon_noimg.png'"
                                                    :preview-src-list="[JSON.parse(item.content).LinkUrl]">
                                                </el-image>
                                                <img v-if="item.contentType=='14' || (item.contentType=='2' && !JSON.parse(item.content).LinkUrl)" style="max-width: 120px;max-height: 214px;vertical-align: middle" :src="JSON.parse(item.content).Thumb ? JSON.parse(item.content).Thumb : '/static/img/icon_noimg.png'" alt="">
                                            </div>
                                            <p v-else>[不支持的图片类型，请在手机上查看]</p>
                                        </div>
                                        <!-- audio -->
                                        <div class="audiobtn" v-else-if="item.contentType =='3'" @click="playamr(JSON.parse(item.content).LinkUrl,item.id)">
                                            <audio :id="'audio'+item.id" :src="'http://'+JSON.parse(item.content).LinkUrl"></audio>
                                            <div class="wifi-symbol" :class="{playaudio:audioid == item.id}">
                                                <div class="wifi-circle first"></div>
                                                <div class="wifi-circle second"></div>
                                                <div class="wifi-circle third"></div>
                                            </div>
                                            <em>{{ item.content | audioduration }}</em>
                                        </div>
                                        <!-- 视频 -->
                                        <div class="videobox" v-else-if="item.contentType =='4'">
                                            <video :id="'video'+item.id" :src="JSON.parse(item.content).LinkUrl"
                                                controls v-show="videoid == item.id"></video>
                                            <div class="videocover" v-show="videoid != item.id">
                                                <img :src="JSON.parse(item.content).Thumb ? JSON.parse(item.content).Thumb : '/static/img/icon_novideo.png'" alt="">
                                                <a v-if="JSON.parse(item.content).LinkUrl" @click="playvideo(JSON.parse(item.content).LinkUrl,item.id)" href="javascript:;"></a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="chattxt" v-else-if="item.contentType=='1'">
                                        <!-- 文字 -->
                                        <p v-html="$options.filters.realcontent(item.content)"></p>
                                    </div>

                                    <!-- 链接 -->
                                    <div class="chattxt chatlink" v-else-if="item.contentType=='18'">
                                        <!-- loading -->
                                        <i class="loading" v-loading="item.sendStatus =='1'&&item.isSend=='true'"></i>
                                        <!-- 发送失败 -->
                                        <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                        <!-- 文字 -->
                                        <a :href="JSON.parse(item.content).linkUrl" target="_blank">
                                            <p class="linktitle">{{JSON.parse(item.content).title}}</p>
                                            <div class="clearfix">
                                                <p class="linkdes fl">{{JSON.parse(item.content).des}}</p>
                                                <img class="linkimg fr" :src="JSON.parse(item.content).coverUrl"/>
                                            </div>
                                        </a>

                                    </div>

                                    <!-- 扩展链接 -->
                                    <!-- <div class="chattxt" v-else-if="item.contentType=='6'">
                                        <i class="loading" v-loading="item.sendStatus =='1'&&item.isSend=='true'"></i>
                                        <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                        <a :href="JSON.parse(item.content)" target="_blank">{{JSON.parse(item.content)}}</a>
                                    </div> -->

                                    <!-- 文件 -->
                                    <div class="chattxt chatlink" v-else-if="item.contentType=='8'" :class="{'nop':JSON.parse(item.content).Des.split(',')[1] == ' mp3'}">
                                        <!-- loading -->
                                        <i class="loading" v-loading="item.sendStatus =='1'&&item.isSend=='true'"></i>
                                        <!-- 发送失败 -->
                                        <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                        <!-- 文字 -->
                                        <audiopaly v-if="JSON.parse(item.content).Des.split(',')[1] == ' mp3'" :mp3url="JSON.parse(item.content).Url"></audiopaly>

                                        <div v-else class="chatfile">
                                            <a :href="JSON.parse(item.content).Url ? JSON.parse(item.content).Url : 'javascript:;'">
                                                <b class="iconfont chatfile_xls" v-if="JSON.parse(item.content).Des.split(',')[1] == ' xls' || JSON.parse(item.content).Des.split(',')[1] == ' xlsx'">&#xe732;</b>
                                                <b class="iconfont chatfile_ppt" v-if="JSON.parse(item.content).Des.split(',')[1] == ' ppt' || JSON.parse(item.content).Des.split(',')[1] == ' pptx'">&#xe731;</b>
                                                <b class="iconfont chatfile_doc" v-if="JSON.parse(item.content).Des.split(',')[1] == ' doc' || JSON.parse(item.content).Des.split(',')[1] == ' docx'">&#xe737;</b>
                                                <b class="iconfont chatfile_pdf" v-if="JSON.parse(item.content).Des.split(',')[1] == ' pdf'">&#xe732;</b>
                                                <p>{{JSON.parse(item.content).Title}}</p>
                                                <span>{{JSON.parse(item.content).Des.split(',')[0]}}</span>
                                            </a>
                                        </div>
                                    </div>

                                    <!-- 名片 -->
                                    <div class="chattxt" v-else-if="item.contentType=='9'">
                                        <!-- loading -->
                                        <i class="loading" v-loading="item.sendStatus =='1'&&item.isSend=='true'"></i>
                                        <!-- 发送失败 -->
                                        <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                        <!-- 文字 -->
                                        <p>[对方发来名片，请在手机上查看]</p>
                                    </div>

                                    <!-- 位置 -->
                                    <div class="chattxt" v-else-if="item.contentType=='10'">
                                        <!-- loading -->
                                        <i class="loading" v-loading="item.sendStatus =='1'&&item.isSend=='true'"></i>
                                        <!-- 发送失败 -->
                                        <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                        <!-- 文字 -->
                                        <p>[对方发来位置，请在手机上查看]</p>
                                    </div>

                                    <!-- 红包 -->
                                    <div class="chatred_box" v-else-if="item.contentType=='11'">
                                        <div class="chatred_con" :class="{ active: JSON.parse(item.content).receiveStatus!= '1' }">
                                            <div class="chatred">
                                                <div class="tit">{{ JSON.parse(item.content).Title }}</div>
                                                <div class="state">{{ hbstate[JSON.parse(item.content).receiveStatus] }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 转账 -->
                                    <div class="chattxt" v-else-if="item.contentType=='12'">
                                        <!-- loading -->
                                        <i class="loading" v-loading="item.sendStatus =='1'&&item.isSend=='true'"></i>
                                        <!-- 发送失败 -->
                                        <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                        <!-- 文字 -->
                                        <p>[收到转账，请在手机上查看]</p>
                                    </div>

                                    <!-- 收到小程序 -->
                                    <div class="chattxt" v-else-if="item.contentType=='13'">
                                        <!-- loading -->
                                        <i class="loading" v-loading="item.sendStatus =='1'&&item.isSend=='true'"></i>
                                        <!-- 发送失败 -->
                                        <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                        <!-- 文字 -->
                                        <p>[收到小程序，请在手机上查看]</p>
                                    </div>

                                    <!-- 语音聊天 -->
                                    <div class="chattxt" v-else-if="item.contentType=='19'">
                                        <p>{{ item.content }} <span class="chat_yp"></span></p>
                                    </div>
                                    <!-- 视频聊天 -->
                                    <div class="chattxt" v-else-if="item.contentType=='20'">
                                        <p>{{item.content}}<span class="chat_sp"></span></p>
                                    </div>

                                    <!-- 不支持的消息类型 -->
                                    <div class="chattxt" v-else>
                                        <!-- loading -->
                                        <i class="loading" v-loading="item.sendStatus =='1'&&item.isSend=='true'"></i>
                                        <!-- 发送失败 -->
                                        <i class="iconfont ic_err" v-show="item.sendStatus == '3'&&item.isSend=='true'">&#xe69f;</i>
                                        <!-- 文字 -->
                                        <p>[不支持的消息，请在手机上查看]</p>
                                        <!-- <img :src="item.content" alt=""> -->
                                    </div>

                                    <div class="clearfix chatbot">
                                        <span class="name" v-if="item.isSend == 'true'">{{item.nickname}}</span>
                                        <span class="name" v-if="item.isSend == 'false'">{{item.remark ? item.remark+ ' - ':''}}{{item.nickname}}</span>
                                        <span class="time">{{item.createTime}}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </el-scrollbar>
            </div>

        </div>
    </div>
</template>

<script>
    import {
        findManagePageWechatMessage,
        getMsgOutsideRelationCount,
        saveMessageOutsideRelations,
        findMessageRecordContext
    } from '@/utils/api-im.js'
    import audiopaly from '@/components/mp3Play'
    export default {
        name: 'chatdailog1',
        data() {
            return {
                hbstate: ['','未领取','已领取','已过期'], //红包状态
                usermsg: {},
                chatmsg: {
                    startindex: -1,
                    endindex: -1,
                    lists: [],
                    idlists: []
                }, //选中的聊天记录
                page: 0, //分页计数
                ismore: true, //是否显示更多聊天记录按钮
                issearchtime: false, //是否是搜索聊天记录
                showchatdailg: 3, //聊天弹窗状态 1 默认 2 聊天记录 3 可选聊天记录
                chatdata: [],
                wxSendTime: '',
                msgid:'',
                oid: '',
                isrechoose: 0,
                localdata: [], //缓存已选的聊天记录
                audioid: 0,
                videoid:0,//播放的视频id
                msgscrolltop: 0,
                scrollflag: false,
                srcList: [],
                errorImg: "this.src='/static/img/defaluttx.png'",
                isupdown:false,
                timer:null,
                ifall:false,
                firstid:'',
                scrollflagd: false,
                iscenter:false
            };
        },

        watch: {
            rowdata () {
                console.log('rowdata')
                this.chatdata = []
                this.showchatdailg = 2
                this.scrollflag = false
                this.getHistoryWechatMessage({
                    "friendid": this.rowdata.friendid,
                    "wechatid": this.rowdata.wechatid,
                    "wxSendId": '',
                    "endDateTime": this.timerange ? this.timerange[1] : '',
                    "startDateTime": this.timerange ? this.timerange[0] : ''

                })
            },
            searchdata() {
                this.chatdata = []
                this.iscenter =true
                console.log('searchdata',this.searchdata.wxSendTime)
            },
            timerange(){
                console.log('asdasdasdsad')
                this.chatdata = []
                this.showchatdailg = 2
                this.scrollflag = false
                this.getHistoryWechatMessage({
                    "friendid": this.rowdata.friendid,
                    "wechatid": this.rowdata.wechatid,
                    "wxSendId": '',
                    "endDateTime": this.timerange ? this.timerange[1] : '',
                    "startDateTime": this.timerange ? this.timerange[0] : ''

                })
            }
        },
        components:{
            audiopaly
        },
        props: {
            rowdata: {},
            searchdata:{},
            timerange:{}
        },
        mounted() {
            this.showchatdailg = 2
            //
            if(this.searchdata && this.searchdata.type){
                //type 1 , 2
                this.iscenter =true
                console.log(this.searchdata,'this.searchdata')
                this.getsearchdata({
                    wxSendTime:this.searchdata.wxSendTime,
                    messageId:this.searchdata.messageId,
                    orderByAsc:'DESC'//DESC ASC
                },true)
                // this.rowdata = {
                //     friendid:this.searchdata.friendid,
                //     wechatid:this.searchdata.wechatid
                // }
                this.firstid = this.searchdata.messageId
                this.wxSendTime = this.searchdata.wxSendTime
                console.log(this.searchdata,'searchdata')
                // this.getmsg()
                this.isupdown = true
            }else{
                this.getmsg()
            }

        },

        methods: {

            getsearchdata(msg,bool) {
                //查询聊天记录
                if(this.scrollflagd){
                    return false
                }
                this.$post(findMessageRecordContext, msg).then(res => {
                    if (res.data.code == '200') {
                        let arrlist = res.data.data;
                        if (arrlist.length == 20) {
                            setTimeout(() => {
                                this.ismore = true
                                if(msg.orderByAsc == "ASC"){
                                    this.scrollflagd = false
                                }
                            }, 1000)
                            //查询更多记录无隐藏更多按钮
                            if(msg.orderByAsc == "ASC"){//执行底部加载
                                //是否拉倒了底部
                                this.ifall = false
                            }
                        } else {
                            if(msg.orderByAsc == "ASC"){
                                this.ifall = true
                                this.scrollflagd =true
                                this.ismore = false
                            }
                        }

                        if(bool){
                            //初次进入有更多数据
                            console.log(msg.orderByAsc, this.iscenter,'00000')
                            if(msg.orderByAsc == "DESC" && this.iscenter){
                                //初次进入定位到所搜文字
                                this.getsearchdata({
                                    wxSendTime:this.searchdata.wxSendTime,
                                    messageId:this.searchdata.messageId,
                                    orderByAsc:'ASC'//DESC ASC
                                })

                            }
                        }
                        msg.orderByAsc == "DESC"? arrlist = arrlist.reverse():''
                        if (this.chatdata == undefined || this.chatdata.length == 0 || msg.orderByAsc == "DESC") {
                            //初次查询记录储存全部
                            this.chatdata =  arrlist
                            this.scrollbottom(true)
                        } else {
                            //更多查询记录储存
                            if(msg.orderByAsc == "ASC"){
                                console.log(this.chatdata,'this.chatdata')
                                const arr = [...this.chatdata,...arrlist]
                                this.chatdata = this.unique(arr)
                            }
                        }
                        this.firstid = this.chatdata[this.chatdata.length-1].id
                        this.wxSendTime = this.chatdata[this.chatdata.length-1].wxSendTime
                        this.wxSendTime = this.chatdata[0].wxSendTime
                        if(msg.orderByAsc == "ASC" && this.iscenter){
                            this.iscenter = false
                            $('#id'+this.searchdata.messageId)[0].scrollIntoView();
                        }
                    }else{
                        this.$message.error(res.data.msg);
                    }

                }).catch(res => {
                    // console.log(res,"sss")
                })
            },
            unique(arr) {
                const res = new Map();
                return arr.filter((a) => !res.has(a.id) && res.set(a.id, 1))
            },

            group(array, subGroupLength) {
                let index = 0;
                let newArray = [];
                while (index < array.length) {
                    newArray.push(array.slice(index, index += subGroupLength));
                }
                return newArray;
            },

            getsrcList(url, id) {
                if (!url) {
                    this.$message.error('无高清图！');
                    return false
                }
                let lurl = url;
                this.$nextTick(() => {
                    let dom = $('.el-icon-download');
                    if (dom) {
                        dom.remove()
                    }
                    let str = document.createElement("i")
                    str.setAttribute('class', 'el-icon-download')
                    let _this = this;
                    $('.el-image-viewer__actions__inner').append(str)
                    $('.el-image-viewer__actions__inner .el-icon-download').on('click',function(){
                        _this.downloadIamge(lurl)
                    })
                })

            },

            downloadIamge(imgsrc, name) { //下载图片地址和图片名
                var image = new Image();
                // 解决跨域 Canvas 污染问题
                image.setAttribute("crossOrigin", "anonymous");
                let _this = this;
                image.src = imgsrc;
                image.onload = function() {
                    var canvas = document.createElement("canvas");
                    canvas.width = image.width;
                    canvas.height = image.height;
                    var context = canvas.getContext("2d");
                    context.drawImage(image, 0, 0, image.width, image.height);
                    var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
                    console.log(url)
                    var a = document.createElement("a"); // 生成一个a元素
                    var event = new MouseEvent("click"); // 创建一个单击事件
                    a.download = ''; // 设置图片名称
                    var blob = _this.dataURLtoBlob(url);
                    var objurl = URL.createObjectURL(blob);
                    a.href = objurl; // 将生成的URL设置为a.href属性
                    a.dispatchEvent(event); // 触发a的单击事件
                };
                image.src = imgsrc;
            },

            dataURLtoBlob(dataurl) {
                var arr = dataurl.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {
                    type: mime
                });
            },

            playvideo(val, id) {
                if (!val) {
                    // this.$message.error('正在接收，请稍后再试');
                    return false
                }
                let videodom = document.getElementById('video' + id)
                let olddom = document.getElementById('video' + this.videoid)
                if (this.videoid == id) {
                    if (videodom.paused) {
                        this.videoid = id;
                    } else {
                        videodom.pause(); //暂停
                    }
                } else {
                    if (this.videoid != '0') {
                        olddom.pause();
                    }
                    videodom.play(); //播放
                    this.videoid = id;
                    let _this = this
                    videodom.addEventListener('ended', function() {
                        _this.videoid = 0
                    }, false);
                }
            },

            playamr(val, id) {
                let audiodom = document.getElementById('audio' + id)
                let olddom = document.getElementById('audio' + this.audioid)
                audiodom.play();
                if (this.audioid == id) {
                    if (audiodom.paused) {
                        this.audioid = id;
                        audiodom.play(); //播放

                    } else {
                        audiodom.pause(); //暂停
                    }
                } else {
                    if (this.audioid != '0') {
                        olddom.pause();
                    }
                    audiodom.play(); //播放
                    this.audioid = id;
                    let _this = this
                    audiodom.addEventListener('ended', function() {
                        _this.audioid = 0
                    }, false);
                }
            },
            //拉取最近的聊天记录
            getmsg() {
                //请求聊天记录
                this.getHistoryWechatMessage({
                    "friendid": this.rowdata.friendid,
                    "wechatid": this.rowdata.wechatid,
                    "wxSendId": '',
                    "endDateTime": this.timerange ? this.timerange[1] : '',
                    "startDateTime": this.timerange ? this.timerange[0] : ''
                })
            },

            //更多聊天记录
            getmoreHistoryWechatMessage() {
                this.getHistoryWechatMessage({
                    "friendid": this.rowdata.friendid,
                    "wechatid": this.rowdata.wechatid,
                    "wxSendTime": this.wxSendTime,
                    "endDateTime": this.timerange ? this.timerange[1] : '',
                    "startDateTime": this.timerange ? this.timerange[0] : ''
                })
            },

            getHistoryWechatMessage(msg) {
                //查询聊天记录
                if(this.scrollflag){
                    return false
                }
                this.scrollflag = true
                this.$post(findManagePageWechatMessage, msg).then(res => {
                    if (res.data.code == '200') {
                        let arrlist = res.data.data;
                        if (arrlist.length == 20) {
                            setTimeout(() => {
                                this.ismore = true
                                this.scrollflag = false
                            }, 500)
                            //查询更多记录无隐藏更多按钮


                        } else {
                            this.ismore = false
                        }
                        arrlist = arrlist.reverse()
                        if (this.chatdata == undefined || this.chatdata.length == 0) {
                            //初次查询记录储存全部
                            this.chatdata =  arrlist
                            this.scrollbottom()
                        } else {
                            //更多查询记录储存
                            this.chatdata = arrlist.concat(this.chatdata)
                            this.$nextTick(() => {
                                let scrolldiv = null;
                                scrolldiv = this.$refs['scrollbar'].$refs['wrap'];
                                scrolldiv.scrollTop = scrolldiv.scrollHeight - this.msgscrolltop
                            })
                        }
                        this.wxSendTime = arrlist[0].wxSendTime
                        console.log(this.chatdata.length,'this.chatdata')
                    }

                }).catch(res => {
                    // console.log(res,"sss")
                })
            },

            //关闭聊天弹窗
            closechat() {
                this.$emit('closeDailog', false); // 直接修改父组件的属性
            },

            //聊天内容拉到最下面
            scrollbottom(bool) {
                //聊天内容拉到最下面
                this.$nextTick(() => {
                    let scrolldiv = null;
                    scrolldiv = this.$refs['scrollbar'].$refs['wrap'];
                    if(!bool){
                        scrolldiv.scrollTop = scrolldiv.scrollHeight
                    }
                    console.log(this.scrollflag,'&&1111')
                    // if (this.scrollflag) {
                        scrolldiv.addEventListener('scroll', () => {
                            this.msgscrolltop = scrolldiv.scrollHeight - scrolldiv.scrollTop
                            console.log(this.scrollflag,'&&3333')
                            if (scrolldiv.scrollTop < 10 ) {
                                console.log(this.scrollflag,'&&3333')
                                this.getmoreHistoryWechatMessage()

                            }
                            // console.log(scrolldiv.scrollHeight,scrolldiv.scrollTop)
                            let let1 = scrolldiv.scrollTop;//滚动条滚动距离
                            let let2 = scrolldiv.scrollHeight;//浏览器总高度
                            let let3 =$('.chatCon').height(); //浏览器可见高度
                            // console.log('666666',parseInt(let1 + let3) - parseInt(let2))
                            if(parseInt(let1 + let3) - parseInt(let2) ==0){
                                if(this.isupdown){

                                    clearTimeout(this.timer);
                                    if(!this.ifall){
                                        this.ifall = true
                                        this.timer = setTimeout(() => {
                                            this.getsearchdata({
                                                wxSendTime:this.wxSendTime,
                                                messageId:this.firstid,
                                                orderByAsc:'ASC'
                                            },true)
                                        }, 1000);
                                    }
                                }
                            }
                        })
                    // }
                })

            }

        }
    };
</script>
<style lang="less" scoped>
    /* 聊天窗口 */
    .chat {
        min-width: 420px;
        background: #fff;
        height: 100%;

        /* 聊天窗弹起*/
        .chatdailg {
            width: 817px;

            .mask {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.3);
                z-index: 999;
            }

            .chatbox {
                background: #fff;
                position: fixed;
                height: 620px;
                top: 100px;
                z-index: 1000;
                left: 20%;

                .chatCon {
                    height: 620px;
                }

            }

            /* 选择聊天记录*/
            .selectchatmsg {
                background: #F3F5F7;

                .chatCon {
                    height: 488px;

                    li {
                        position: relative;

                        &>i {
                            display: block;
                            position: absolute;
                            top: 46px;
                            left: 30px;
                            width: 16px;
                            height: 16px;
                            border: 1px solid rgba(204, 204, 204, 1);
                            border-radius: 50%;
                            cursor: pointer;

                            s {
                                display: none;
                            }
                        }

                        &:hover>i {
                            border: 1px solid rgba(204, 204, 204, 1);
                            border-radius: 50%;
                            cursor: pointer;
                            background: #C5C9CC;

                            s {
                                display: block;
                                color: #fff;
                            }
                        }

                        &>i.active {
                            border: 1px solid #0099FF;
                            border-radius: 50%;
                            background: #0099FF;
                            cursor: pointer;

                            s {
                                display: block;
                                color: #fff;
                            }
                        }
                    }

                    .chatmsg {
                        padding-left: 74px;

                        &:hover {
                            background: rgba(28, 35, 43, 0.03);
                        }


                    }
                }

                .btn_box {
                    border-top: 1px solid #E1E6F0;
                    text-align: center;

                    a {
                        display: inline-block;
                        width: 76px;
                        height: 32px;
                        border: 1px solid rgba(218, 222, 224, 1);
                        border-radius: 2px;
                        line-height: 32px;
                        margin: 20px 4px 0;
                        font-size: 14px;
                    }

                    .btn_cancel {
                        color: #93999F;
                    }

                    .btn_sendchat {
                        border-color: #0099FF;
                        background: #0099FF;
                        color: #fff;
                    }
                }
            }
        }

        /* 默认头部样式*/
        .title {
            height: 48px;
            line-height: 48px;
            position: relative;
            background: #fff;

            .txt {
                padding-left: 20px;
            }

            /* 关闭按钮*/
            .btn_close {
                width: 12px;
                height: 12px;
                position: absolute;
                top: 18px;
                right: 18px;
            }

            /* 跟单按钮*/
            .btn_documentary {
                width: 76px;
                height: 32px;
                background: #0099ff;
                border-radius: 2px;
                display: block;
                position: absolute;
                bottom: 8px;
                right: 20px;
                text-align: center;
                line-height: 32px;
                color: #fff;
            }
        }

        /* 时间组件微调*/
        .timeSelect {

            .el-date-editor--datetimerange.el-input,
            .el-date-editor--datetimerange.el-input__inner {
                width: 365px;
            }

            .el-input__inner {
                border: none;
            }

            .el-range-editor.is-active,
            .el-range-editor.is-active:hover {
                color: #fff;
            }
        }

        /* 聊天主体*/
        .chatCon {
            background: #F3F5F7;
            height: calc(100vh - 225px);
            min-height: 260px;

            /* 查看更多按钮*/
            .btn_moreinfo {
                height: 18px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(0, 153, 255, 0.8);
                line-height: 18px;
                display: block;
                text-align: center;
                padding-top: 18px;
            }

            .searchResult {
                margin-top: 20px;
            }

            .searchResult p,
            .time {
                color: #707478;
                font-size: 12px;
                text-align: center;
                line-height: 18px;
            }

            /* 消息列表*/
            .chatlist {

                li {

                    &>i {
                        display: none;

                        s {
                            text-decoration: none;
                        }
                    }

                    &>.time {
                        margin: 14px 0;
                    }

                    .chattip{
                        padding: 10px 40px;
                        line-height: 30px;
                        font-size: 12px;
                        color: #707478;
                        text-align: center;
                        .red_state{
                            margin-top: 12px;
                            color: #2A2A2A;
                            img{
                                height: 20px;
                                width: 20px;
                                vertical-align: middle;
                            }
                            span{
                                color: #ECA235;
                            }
                        }
                    }

                    .imgshowbox{
                        p{
                            padding: 12px 15px 12px 15px;
                        }
                    }

                    .chatmsg {
                        padding: 16px 20px;

                        &>img {
                            width: 36px;
                            height: 36px;
                            border-radius: 50%;
                        }

                        .chatred_con{
                            width: 221px;
                            height: 82px;
                            position: relative;
                            cursor: pointer;

                            .chatred{
                                position: absolute;
                                top: 10px;
                                left: 60px;
                                color: #fff;
                                .tit{
                                    width: 150px;
                                    height: 20px;
                                    line-height: 20px;
                                    overflow: hidden;
                                    text-overflow:ellipsis;
                                    white-space: nowrap;
                                }
                                .state{
                                    margin-top: 5px;
                                    font-size: 12px;
                                }
                            }
                        }

                        .chattxt {
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 18px;
                            border-radius: 3px;
                            max-width: 375px;
                            padding: 12px 15px 12px 15px;
                            position: relative;
                            word-wrap: break-word;

                            &::after {
                                content: '';
                                position: absolute;
                                top: 12px;
                                width: 0;
                                height: 0;
                                border-width: 7px;
                                border-style: solid;
                            }

                            i {
                                position: absolute;
                                top: 50%;
                                transform: translateY(-50%);
                                left: -40px;
                                color: #000000;
                                font-size: 18px;
                            }

                            .loading {
                                top: 20px;
                                transform: scale(0.6);
                            }


                            .ic_err {
                                color: firebrick;
                            }

                            &.nop {
                                padding: 0;
                            }

                            .audiobtn {
                                min-width: 80px;
                                width: 100%;
                                height: 40px;
                                cursor: pointer;
                                position: relative;

                                em {
                                    position: absolute;
                                    top: 10px;
                                    color: #333;
                                }

                                audio {
                                    display: none;
                                }
                            }

                            .videobox {
                                position: relative;
                                max-width: 375px;

                                a {
                                    position: absolute;
                                    left: 50%;
                                    top: 50%;
                                    transform: translate(-50%, -50%);
                                    display: block;
                                    width: 40px;
                                    height: 40px;
                                    background: url(/static/img/play_icon1.png) center no-repeat;
                                    background-size: 100% 100%;
                                }
                            }

                            .chat_yp,.chat_sp{
                                display: inline-block;
                                vertical-align: middle;
                                width: 24px;
                                height: 18px;
                                background: url(/static/img/icon_yp_r.png) center no-repeat;
                                background-size: 24px 12px;
                                margin-left: 8px;
                            }
                            .chat_sp{
                                background: url(/static/img/icon_sp_r.png) center no-repeat;
                                background-size: 24px 18px;
                            }
                        }

                        .linktitle{
                            font-size: 14px;
                            line-height: 19px;
                            width: 280px;
                            margin-bottom: 10px;
                            color: #333;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;

                            &:hover{
                                color: #0099FF;
                            }
                        }

                        .linkdes{
                            font-size: 12px;
                            line-height: 18px;
                            width: 206px;
                            color: #93999F;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                        }

                        .linkimg{
                            width: 50px;
                            height: 50px;
                        }

                        .chatother {
                            padding: 0;
                            min-height: 40px;
                            min-width: 50px;
                            text-align: center;

                            video {
                                width: 375px;
                                vertical-align: middle;
                            }

                            img {
                                max-width: 375px;
                                vertical-align: middle;
                            }
                            &::after {
                                display: none;
                            }
                        }

                        .chatbot {
                            padding-top: 8px;

                            span {
                                font-size: 12px;
                                line-height: 18px;
                            }

                            .name {
                                color: #93999F;
                            }

                            .time {
                                color: #B5B9BC;
                            }
                        }
                        .chatfile{
                            position: relative;

                            b{
                                position: absolute;
                                top: 12px;
                                left: 0;
                                display: block;
                                font-size: 38px;
                                color: blue;
                            }

                            .chatfile_doc{
                                color: #5DACFF;
                            }

                            .chatfile_xls{
                                color: #5ACC9B;
                            }
                            .chatfile_ppt{
                                color: #FF8A76;
                            }
                            .chatfile_pdf{
                                color: #FF6969;
                            }
                        }


                    }
                }

                /* 收到的消息*/
                .chatreceive {
                    .chatmsg {

                        &>img {
                            float: left;
                        }

                        .chattxt {
                            background: #E6E8EC;
                            color: #4C4C4C;
                            float: left;
                            margin-left: 15px;

                            &::after {
                                left: -14px;
                                border-color: transparent #E6E8EC transparent transparent;
                            }

                            .audiobtn {
                                em {
                                    right: -20px;
                                }

                                .wifi-symbol {
                                    transform: rotate(135deg) scale(0.6);
                                    left: 15px;
                                }
                            }

                            .chat_yp {
                                float: left;
                                background: url(/static/img/icon_yp_l.png) center no-repeat;
                                background-size: 24px 12px;
                            }

                            .chat_sp{
                                float: left;
                                margin-right: 8px;
                                background: url(/static/img/icon_sp_l.png) center no-repeat;
                                background-size: 24px 18px;
                            }
                        }

                        .chatlink{
                            background: #fff;
                            &::after {
                                border-color: transparent #fff transparent transparent;
                            }

                            .chatfile {
                                padding-right: 50px;

                                b{
                                    left:auto;
                                    right: 0;
                                }

                                p{
                                    font-size: 14px;
                                    color: #2A2A2A;
                                    width: 189px;
                                }
                                span{
                                    font-size: 12px;
                                    color: #93999F;
                                }
                            }
                        }

                        .chatbot {
                            clear: both;
                            margin-left: 58px;

                            .name {
                                float: left;
                            }

                            .time {
                                float: left;
                                margin-left: 10px;
                            }
                        }
                        .chatred_con{
                            background: url(/static/img/red_l.png) no-repeat;
                            background-size: 100% 100%;
                            margin-left: 47px;
                            position: relative;
                            &.active{
                                background: url(/static/img/red_l_o.png) no-repeat;
                                background-size: 100% 100%;
                            }
                        }
                        .red_state{
                            float: left;
                            margin-left: 7px;
                        }
                    }

                }

                /* 发送的消息*/
                .chatsend {
                    .chatmsg {
                        &>img {
                            float: right;
                        }

                        .chattxt {
                            float: right;
                            background: linear-gradient(90deg, rgba(46, 140, 228, 1), rgba(23, 129, 231, 1));
                            color: #fff;
                            margin-right: 15px;

                            &::after {
                                right: -14px;
                                border-color: transparent transparent transparent rgba(23, 129, 231, 1);
                            }

                            .audiobtn {
                                em {
                                    left: -20px;
                                }

                                .wifi-symbol {
                                    transform: rotate(-45deg) scale(0.6);
                                    right: 15px;
                                }

                                .wifi-circle {
                                    border: 5px solid rgba(255, 255, 255, 0.6);
                                }

                                .first {
                                    background: rgba(255, 255, 255, 0.4);
                                }
                            }
                        }

                        .chatlink{
                            background: #fff;
                            &::after {
                                border-color: transparent #fff transparent transparent;
                            }

                            .chatfile {
                                padding-left: 50px;

                                p{
                                    font-size: 14px;
                                    color: #2A2A2A;
                                    width: 189px;
                                }
                                span{
                                    font-size: 12px;
                                    color: #93999F;
                                }
                            }
                        }

                        .chatbot {
                            clear: both;
                            margin-right: 58px;

                            .name {
                                float: right;
                                margin-left: 10px;
                            }

                            .time {
                                float: right;

                            }
                        }

                        .chatred_box {
                            float: right;
                            .chatred_con{
                                background: url(/static/img/red_r.png) no-repeat;
                                background-size: 100% 100%;
                                margin-right: 7px;
                                position: relative;
                                &.active{
                                    background: url(/static/img/red_r_o.png) no-repeat;
                                    background-size: 100% 100%;
                                }
                            }
                            .red_state{
                                float: right;
                                margin-right: 7px;
                            }
                        }
                    }

                }
            }
        }

        .cannosend {
            height: calc(100vh - 108px);
        }

        /* 输入框*/
        .textArea {
            height: 216px;
            border-top: 1px solid #E1E6F0;
            background: #F8F9FA;
            position: relative;

            /* 表情框 */
            .expression {
                position: relative;

                &>a {
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    margin: 10px 0 10px 20px;
                }

                .expressionlist {
                    position: absolute;
                    bottom: 30px;
                    background: #fff;
                    padding: 10px;
                    height: 180px;

                    li {
                        width: 20px;
                        height: 20px;
                        margin: 8px;
                        float: left;

                        a {
                            width: 24px;
                            height: 20px;
                            background: url(/static/img/qqface.png) -4px -4px no-repeat;
                        }

                        img {
                            width: 24px;
                            height: 24px;
                        }

                        /* 表情*/
                        .intro-loop(105);

                        .intro-loop(@n, @i: 1) when (@i <=@n) {
                            .intro-@{i} {
                                background-position: -4px + -29px * mod(@i , 15) -4px + -29px *floor(@i / 15);
                            }

                            .intro-loop(@n, (@i + 1))
                        }

                        .intromoji-loop(284);

                        .intromoji-loop(@n, @i: 105) when (@i <=@n ) {
                            .intromoji-@{i} {
                                background: url(/static/img/emoji.png) no-repeat;
                                background-size: 434px auto;
                                background-position: 1px+ -29px * mod(@i , 15) 202px + -29px *floor(@i / 15);
                            }

                            .intromoji-loop(@n, (@i + 1))
                        }

                    }
                }
            }

            .chatinput {
                outline: none;
                padding: 10px;
                width: calc(100% - 20px);
                height: 90px;
                background: transparent;
                border: none;
                resize: none;

            }

            /* 发送按钮 */
            .btn_send {
                width: 76px;
                height: 32px;
                background: rgba(0, 153, 255, 1);
                border-radius: 2px;
                display: block;
                position: absolute;
                bottom: 24px;
                right: 20px;
                text-align: center;
                line-height: 32px;
                color: #fff;
            }
        }

        .gray_bg {
            background: #999;
        }

        /* 修改备注弹窗 */

        .remarkbox {
            box-shadow: 0px 0px 18px 0px rgba(5, 2, 2, 0.28);
            border-radius: 6px;

            .remarktop {

                .imgbox {
                    height: 40px;
                    width: 40px;
                    float: left;
                    margin-right: 10px;

                    img {
                        height: 40px;
                        width: 40px;
                        border-radius: 50%;
                    }
                }

                .name {
                    font-size: 14px;
                    line-height: 18px;
                    color: #333333;
                }

                .wxname {
                    font-size: 12px;
                    line-height: 18px;
                    margin-top: 6px;
                    color: #93999F;
                }
            }

            .remarkbot {
                margin-top: 18px;
                border-top: 1px solid rgba(226, 231, 235, 1);
                padding-top: 10px;
                line-height: 32px;
                font-size: 14px;

                &>span {
                    color: #93999F;
                }

                .editnickname {
                    display: inline-block;
                    height: 28px;
                    margin-left: 20px;
                    width: 260px;

                    input {
                        width: 240px;
                        height: 28px;
                        padding: 0 10px;
                        border: 1px solid #0099FF;
                        border-radius: 2px;
                    }

                    i {
                        cursor: pointer;
                    }
                }


            }
        }

        .searchchat{
            height: 100%;

            .chatCon{
                height: 100%;
            }
        }

    }

    // 微信语音
    .wifi-symbol {
        width: 50px;
        height: 50px;
        box-sizing: border-box;
        overflow: hidden;
        position: absolute;
        top: -5px;
    }

    .playaudio .second {
        animation: fadeInOut 1s infinite 0.2s;
    }

    .playaudio .third {
        animation: fadeInOut 1s infinite 0.4s;
    }

    .wifi-circle {
        border: 5px solid #999999;
        border-radius: 50%;
        position: absolute;
    }

    .first {
        width: 5px;
        height: 5px;
        background: #cccccc;
        top: 45px;
        left: 45px;
    }

    .second {
        width: 20px;
        height: 20px;
        top: 35px;
        left: 35px;
    }

    .third {
        width: 30px;
        height: 30px;
        top: 25px;
        left: 25px;

    }

    @keyframes fadeInOut {
        0% {
            opacity: 0;
            /*初始状态 透明度为0*/
        }

        100% {
            opacity: 1;
            /*结尾状态 透明度为1*/
        }
    }

</style>
<style>
	/* .dialog .el-dialog__body {
		padding: 0px !important;
	}
    .dialog .el-dialog {
        border-radius: 6px;
    }

    .dialog .el-dialog__header {
        display: none;
    } */

    .el-scrollbar__wrap {
        overflow-y: auto !important;
        overflow-x: hidden !important;
    }

    .el-image-viewer__wrapper {
        top: 60px;
    }

    .el-icon-circle-close,
    .el-icon-download {
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/chathistorydailog.vue